import { ReactNode } from 'react';
import { MdErrorOutline, MdInfo, MdInfoOutline, MdWarning } from 'react-icons/md';

const ICONS = {
  info: MdInfoOutline,
  warning: MdWarning,
  error: MdErrorOutline,
  // Deliberately louder than 'info' — for a proactive callout the reviewer needs to
  // notice before acting (e.g. "this data is shared, one review covers it"), not a
  // passive status note. A solid info icon (not MdCheckCircle) -- a checkmark reads as
  // "this is done/verified," which is the wrong message for "here's something to be
  // aware of."
  highlight: MdInfo
} as const;

type InlineAlertVariant = keyof typeof ICONS;

interface InlineAlertProps {
  variant?: InlineAlertVariant;
  title?: string;
  children: ReactNode;
}

export const InlineAlert = ({ variant = 'info', title, children }: InlineAlertProps) => {
  const Icon = ICONS[variant];
  return (
    <div className={`data-qa-inline-alert data-qa-inline-alert--${variant}`}>
      <Icon className='data-qa-inline-alert__icon' />
      <div className='data-qa-inline-alert__content'>
        {title && <div className='data-qa-inline-alert__title'>{title}</div>}
        <div className='data-qa-inline-alert__body'>{children}</div>
      </div>
    </div>
  );
};
